import React, { PropsWithChildren, useContext, useImperativeHandle, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import Constants from 'expo-constants';
import { Turnstile } from '@marsidev/react-turnstile';
import type { TurnstileInstance } from '@marsidev/react-turnstile';
import { useRef } from 'react';
import { HumanVerifierProps } from '@/types/human_verifier_props';

export function HumanVerifier({ onSuccess, ref }: HumanVerifierProps) : React.ReactNode {
  const turnstile = useRef<TurnstileInstance | undefined>(undefined);

  useImperativeHandle(ref, () => ({
    reset: () => {
      turnstile?.current?.reset();
    },
  }), []);

  return (
    <Turnstile
      siteKey={Constants.expoConfig?.extra?.turnstileSiteKey}
      onSuccess={onSuccess}
      ref={turnstile}
    />
  );
};
